"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _getGlobal = _interopRequireDefault(require("./utils/getGlobal"));

var g = (0, _getGlobal["default"])();
/**
 * @deprecated use `cancelAnimationFrame` instead
 */

var cancelAnimationFramePolyfill = g.cancelAnimationFrame || g.clearTimeout;
var _default = cancelAnimationFramePolyfill;
exports["default"] = _default;
module.exports = exports.default;